module.exports = __webpack_public_path__ + "static/media/lista-suspensa-icon.8d9cb8fe.svg";